
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import VuiSwitch from "components/VuiSwitch";
import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets
import radialGradient from "assets/theme/functions/radialGradient";
import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgSignIn from "assets/images/signInImage.png";
import googleLogo from "assets/images/logos/google.svg";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { signIn, signInWithGoogle } = useAuth(); // Obter signInWithGoogle do contexto
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    try {
      const { error } = await signIn({ email, password });
      if (error) {
        throw error;
      }
      navigate("/dashboard");
    } catch (error) {
      alert(error.message);
    }
  };

  const handleGoogleSignIn = () => {
    signInWithGoogle(); // Chama a função do contexto
  };

  return (
    <CoverLayout
      title="Que bom te ver!"
      color="white"
      description="Digite suas credenciais para entrar"
      premotto=""
      mottoLine1="SEU LANÇAMENTO PROTEGIDO:"
      mottoLine2="SAFERDOCK"
      image={bgSignIn}
    >
      <VuiBox component="form" role="form" onSubmit={handleEmailSubmit}>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Email
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            padding="1px"
            borderRadius={borders.borderRadius.lg}
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput type="email" placeholder="Seu e-mail..." fontWeight="500" onChange={(e) => setEmail(e.target.value)} />
          </GradientBorder>
        </VuiBox>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Senha
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            borderRadius={borders.borderRadius.lg}
            padding="1px"
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput
              type="password"
              placeholder="Sua senha..."
              sx={({ typography: { size } }) => ({
                fontSize: size.sm,
              })}
              onChange={(e) => setPassword(e.target.value)}
            />
          </GradientBorder>
        </VuiBox>
        <VuiBox mt={4} mb={1}>
          <VuiButton type="submit" color="info" fullWidth>
            ENTRAR
          </VuiButton>
        </VuiBox>
        {/* Botão de Login com Google - Oculto Temporariamente
        <VuiBox mt={2} mb={1}>
          <VuiButton variant="outlined" color="white" fullWidth onClick={handleGoogleSignIn}>
            <VuiBox component="img" src={googleLogo} alt="Google" sx={{ height: "20px", marginRight: "10px" }} />
            Entrar com Google
          </VuiButton>
        </VuiBox>
        */}
        <VuiBox mt={3} textAlign="center">
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Não tem uma conta?{" "}
            <VuiTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="white"
              fontWeight="medium"
            >
              Cadastre-se
            </VuiTypography>
          </VuiTypography>
          <VuiBox mt={2}>
            <VuiTypography
              component={Link}
              to="/authentication/forgot-password"
              variant="button"
              color="white"
              fontWeight="medium"
            >
              Esqueceu a senha?
            </VuiTypography>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </CoverLayout>
  );
}

export default SignIn;
